import {useEffect, useState} from "react";
import ReactTooltip from "react-tooltip";


export type IListGroupWithNavChildItem = {
  id: number,
  title: string,
  subtitle: string,
}


export type IListGroupWithNavItem = {
  id: number,
  title: string,
  items: IListGroupWithNavChildItem[],
}


export type ListGroupWithNavProps = {
  items: IListGroupWithNavItem[],
  onClickProduct: void,
}

export default function ListGroupWithNav(props: ListGroupWithNavProps) {
  const [activeItem, setActiveItem] = useState(props.items[0]);


  useEffect(() => {
    ReactTooltip.rebuild()
  }, [activeItem])

  useEffect(() => {
    if (props.selectedProduct) {
      setActiveItem(props.items.find(c => c.items.find(p => p.id === props.selectedProduct.id)) ?? props.items[0]);
    } else if (!activeItem) {
      setActiveItem(props.items[0])
    }
  }, [props.items])

  return document.body.offsetWidth < 992 ? (
    <div className="listGroupWithNav">
      <ul className="nav nav-tabs">
        {props.items?.map(c => (
          <li key={c.id} className="nav-item">
            <button
              className={`nav-link ${activeItem?.id === c.id ? 'active' : ''}`}
              onClick={() => setActiveItem(c)}
            >{c.name}</button>
          </li>
        ))}
      </ul>

      <div className="list-group">
        {activeItem?.items.map(i => (
          <button
            key={i.id}
            className="list-group-item listGroupWithNavItem"
            onClick={() => props.onClickProduct(i)}
          >
            <div
              className="listGroupWithNavItem__thumb"
              data-tip={`<img src=${i.image} alt="" style="width: 400px; height: 300px; object-fit: contain"/>`}
              data-effect="solid"
              data-place="right"
              data-html={true}
            >
              <img src={i.image} alt=""/>
            </div>
            <div className="listGroupWithNavItem__content">
              <h3 className="listGroupWithNavItem__title">{i.title}</h3>
              {!!i.text && <p className="listGroupWithNavItem__text" dangerouslySetInnerHTML={{__html: i.text}}/>}
              <p className="listGroupWithNavItem__subtitle">{i.subtitle} <b>{i.price?.toFixed(2)} €</b></p>
            </div>
          </button>
        ))}
      </div>
    </div>
  ) : (
    <div className="listGroupWithNav">
      {props.items?.map(c => (
        <div key={c.id} className="mb-3">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link active`}
                onClick={() => setActiveItem(c)}
              >{c.name}</button>
            </li>
          </ul>

          <div className="list-group">
            {c.items.map(i => (
              <button
                key={i.id}
                className="list-group-item listGroupWithNavItem"
                onClick={() => props.onClickProduct(i)}
              >
                <div
                  className="listGroupWithNavItem__thumb"
                  data-tip={`<img src=${i.image} alt="" style="width: 400px; height: 300px; object-fit: contain"/>`}
                  data-effect="solid"
                  data-place="right"
                  data-html={true}
                >
                  <img src={i.image} alt=""/>
                </div>
                <div className="listGroupWithNavItem__content">
                  <h3 className="listGroupWithNavItem__title">{i.title}</h3>
                  {!!i.text && <p className="listGroupWithNavItem__text" dangerouslySetInnerHTML={{__html: i.text}}/>}
                  <p className="listGroupWithNavItem__subtitle">{i.subtitle} <b>{i.price?.toFixed(2)} €</b></p>
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
